//Imports
import React, { useCallback, useEffect } from "react";

//Controls
import { Button, Modal } from "@gpstrackit/gtc-react-controls";

//Components
import {
    NotificationManager,
    NotificationContainer,
} from "Components/Notifications";

//Hooks
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Actions
import { workOrderDeleteContact, reset } from "./redux/slice";

const DeleteContact = ({ refresh, single }) => {

    //Redux
    const dispatch = useDispatch();
    const { open, loading, result, error, contact, contactList } = useSelector((state) => state.workOrdersDeleteContactRedux);

    //Language
    const { messages } = useIntl();

    //Handlers and utils
    const handleClose = useCallback(() => dispatch(reset()), []);

    //Effects
    useEffect(() => {
        if (error) {
            let errorMessage = messages["errorMessage"];
            const errorLower = error?.error?.toLowerCase();
            if (errorLower.includes('are in use')) {
                errorMessage = messages['manage_deleteContacts_are_in_use']
            }
            NotificationManager.error(
                errorMessage,
                messages["error"],
                3000,
                null,
                null,
                "error"
            );
            dispatch(reset({ error: null }));
        }
    }, [error]);

    useEffect(() => {
        if (!result) return;
        if (result?.delete) {
            const messageSuccess = contact
                ? messages['manage_deleteContact_successMessage']
                : messages['manage_deleteContacts_successMessage'];

            NotificationManager.success(
                messageSuccess,
                messages["success"],
                3000,
                null,
                null,
                "success"
            );
            refresh && refresh();
            dispatch(reset());
        } else {
            NotificationManager.error(
                messages["errorMessage"],
                messages["error"],
                3000,
                null,
                null,
                "error"
            );
            dispatch(reset({ result: null }));
        }
    }, [result]);

    return (
        <Modal
            title={contact ? single ? `${messages['manage_deleteContact_title']} ${contact?.name ? ` "${contact?.name}"` : ''}` : messages['manage_deleteContact_title'] : messages['manage_deleteContacts_title']}
            size="small"
            open={open}
            handleClose={handleClose}
            loading={loading}
            footer={
                <div>
                    <Button
                        variant="secondary"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleClose()}
                        isDisabled={loading}
                    >
                        {messages["cancel"]}
                    </Button>
                    <Button
                        variant="warning"
                        onClick={() => {
                            if (contact) {
                                dispatch(workOrderDeleteContact({ ids: [contact?.id] }));
                            }
                            if (contactList?.length) {
                                let ids = contactList.map((item) => item?.id)
                                dispatch(workOrderDeleteContact({ ids: ids }));
                            }
                        }}
                        isDisabled={loading}
                    >
                        {messages["delete"]}
                    </Button>
                </div>
            }
        >
            <div style={{ padding: "10px 25px" }}>
                <p>{contact ? messages['manage_deleteContact_description'] : messages['manage_deleteContacts_description']}</p>
                {
                    !single && (
                        <ul>
                            {contact ? (
                                <li style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                                    {contact?.name}
                                </li>
                            ) : (
                                contactList?.map((crew, index) => (
                                    <li key={index} style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                                        {crew.name}
                                    </li>
                                ))
                            )}
                        </ul>
                    )
                }
            </div>
            <NotificationContainer />
        </Modal>
    );
};

export default DeleteContact;